import { render, staticRenderFns } from "./BoningPdfExport.vue?vue&type=template&id=7e6530c0"
import script from "./BoningPdfExport.vue?vue&type=script&setup=true&lang=js"
export * from "./BoningPdfExport.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports